import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Button, Form, Spin, message, Tabs, Col, Input } from 'antd';
import { ArrowLeftOutlined, SaveOutlined } from '@ant-design/icons';
import axios from '../utils/axios';
import BreadCrumb from '../components/Breadcrumb';

function ContactAddEdit() {
	const navigate = useNavigate();
	const { editContactId } = useParams();
	const [isLoading, setIsLoading] = useState(false);
	const [form] = Form.useForm();

	// Fetch existing contact if editing
	const get = () => {
		if (!editContactId) return;

		setIsLoading(true);
		axios
			.get(`/contact`, { params: { _id: editContactId } })
			.then((result) => {
				if (Array.isArray(result.data.data) && result.data.data.length) {
					const [data] = result.data.data;
					form.setFieldsValue(data);
				}
			})
			.catch(() => {})
			.finally(() => setIsLoading(false));
	};

	// Save contact data
	const onSave = () => {
		form.validateFields()
			.then((values) => {
				setIsLoading(true);
				if (editContactId) values._id = editContactId;

				axios({
					method: editContactId ? 'put' : 'post',
					url: '/contact',
					data: values,
				})
					.then((result) => {
						if (result.data.success) {
							message.success(result.data.message);
							navigate('/contact');
						} else {
							message.error(result.data.message);
							setIsLoading(false);
						}
					})
					.catch(() => {
						message.error('Oops! Something went wrong!');
						setIsLoading(false);
					});
			})
			.catch((e) => console.log(e));
	};

	useEffect(() => {
		get();
	}, []);

	return (
		<>
			<BreadCrumb breadcrumbs={[{ link: '/', label: 'Home' }, { label: 'Contact Us' }]} />
			<Spin spinning={isLoading}>
				<div className='main-content'>
					<div className='page-header'>
						<div className='page-title'>{editContactId ? 'Edit Contact Us' : 'Add Contact Us'}</div>
						<div className='page-title-more'>
							<Link to='/contact'>
								<Button icon={<ArrowLeftOutlined />}>Back</Button>
							</Link>
							<Button icon={<SaveOutlined />} type='primary' onClick={onSave} loading={isLoading}>
								Save
							</Button>
						</div>
					</div>

					<div className='form-content'>
						<Form form={form} layout='vertical' autoComplete='off'>
							<Tabs
								defaultActiveKey='1'
								items={[
									{
										key: 'Details',
										label: 'Details',
										children: (
											<>
												{/* Contact Person Name */}
												<Col sm={24} md={12}>
													<Form.Item label='Name' name='name' rules={[{ required: true, message: 'Name is required' }]}>
														<Input placeholder='Enter name' autoFocus />
													</Form.Item>
												</Col>

												{/* Email */}
												<Col sm={24} md={12}>
													<Form.Item
														label='Email Us'
														name='email'
														rules={[
															{ required: true, message: 'Email is required' },
															{ type: 'email', message: 'Enter a valid email' },
														]}
													>
														<Input placeholder='Enter email address' />
													</Form.Item>
												</Col>

												{/* Phone */}
												<Col sm={24} md={12}>
													<Form.Item label='Call Us' name='phone' rules={[{ required: true, message: 'Phone number is required' }]}>
														<Input placeholder='Enter phone number' />
													</Form.Item>
												</Col>

												{/* Office Open */}
												<Col sm={24} md={12}>
													<Form.Item label='Office Open' name='office' rules={[{ required: false, message: 'Enter Office Open Time' }]}>
														<Input placeholder='Enter Office Open Time ' />
													</Form.Item>
												</Col>

												{/* Address */}
												<Col sm={24} md={24}>
													<Form.Item label='Office Address' name='address'>
														<Input.TextArea rows={3} placeholder='Enter full address' />
													</Form.Item>
												</Col>

												{/* Google Map iFrame Link */}
												<Col sm={24} md={24}>
													<Form.Item label='Google Map iFrame' name='map' rules={[{ required: false, message: 'Enter Google Map iFrame link' }]}>
														<Input.TextArea rows={3} placeholder='Paste Google Map iframe embed code here' />
													</Form.Item>
												</Col>

												{/* Message */}
												<Col sm={24} md={24}>
													<Form.Item label='Message' name='message'>
														<Input.TextArea rows={4} placeholder='Enter message or notes' />
													</Form.Item>
												</Col>
											</>
										),
									},
								]}
							/>
						</Form>
					</div>
				</div>
			</Spin>
		</>
	);
}

export default ContactAddEdit;
